import {
  mapMerchantsFiltersToParams,
  mapMerchantsSortColumn,
  useMerchantsListQuery,
  type MerchantsListParams,
} from "Api/Queries/Merchants/useGetMerchantsQuery";
import { useMerchantStatsQuery } from "Api/Queries/Merchants/useMerchantStatsQuery";
import { AllMerchantsTable } from "Components/Hunter/AllMerchants/AllMerchantsTable";
import { MerchantsStatusWidgets } from "Components/Hunter/Merchants/MerchantsList/MerchantsStatusWidgets";
import { MerchantsStatusWidgetsSkeleton } from "Components/Hunter/Merchants/MerchantsList/MerchantsStatusWidgetsSkeleton";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useServerTable } from "Hooks/useServerTable";
import type { MerchantListItemDto } from "Infrastructure/Api/Api";
import { useMemo } from "react";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Hunter.AllMerchants;

export const AllMerchantsPageContent = () => {
  const { t } = useResource();
  const { data: statsData, isLoading: isLoadingStats } =
    useMerchantStatsQuery();

  const { queryParams, tableProps } = useServerTable<MerchantListItemDto>({
    defaultSorting: [{ id: "dateCreated", desc: true }],
  });

  const apiParams = useMemo(
    (): MerchantsListParams => ({
      offset: queryParams.offset,
      limit: queryParams.limit,
      sortBy: mapMerchantsSortColumn(queryParams.sortBy),
      sortDirection: queryParams.sortDirection,
      ...mapMerchantsFiltersToParams(queryParams.filters),
    }),
    [queryParams],
  );

  const { data, isLoading, isRefetching } = useMerchantsListQuery(apiParams);

  if (isLoading || isLoadingStats) {
    return (
      <>
        <MerchantsStatusWidgetsSkeleton />
        <AllMerchantsTable data={[]} isLoading tableProps={tableProps} />
      </>
    );
  }

  if (!data && !isLoading) {
    return <ErrorText>{t(RESOURCES.LoadingError)}</ErrorText>;
  }

  return (
    <>
      {statsData && (
        <MerchantsStatusWidgets
          openRegistrations={statsData.openRegistrations}
          invitationsSent={statsData.invitationsSent}
          inOnboarding={statsData.inOnboarding}
          completed={statsData.completed}
        />
      )}
      <AllMerchantsTable
        data={data?.items || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        rowCount={data?.totalCount ?? 0}
        tableProps={tableProps}
      />
    </>
  );
};
